import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../api';

export const PricingContext = createContext();

export const PricingProvider = ({ children }) => {
    const [prices, setPrices] = useState(null);
    const [currency, setCurrency] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPrices = async () => {
            try {
                const response = await api.get('/pricing');
                setPrices(response.data.prices);
                setCurrency(response.data.currency);
            } catch (err) {
                console.error('Error fetching prices:', err);
                // Utiliser des prix par défaut en cas d'erreur
                setPrices({
                    monthly: { id: 'price_default_monthly', unit_amount: 1500, currency: 'usd', period: 'monthly' },
                    quarterly: { id: 'price_default_quarterly', unit_amount: 4000, currency: 'usd', period: 'quarterly' },
                    yearly: { id: 'price_default_yearly', unit_amount: 12000, currency: 'usd', period: 'yearly' }
                });
                setCurrency('usd');
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPrices();
    }, []);

    const formatPrice = (amount) => {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency || 'EUR'
        }).format(amount);
    };

    return (
        <PricingContext.Provider 
            value={{
                prices,
                currency,
                loading,
                error,
                formatPrice
            }}
        >
            {children}
        </PricingContext.Provider>
    );
};
export const usePricing = () => {
    const context = useContext(PricingContext);
    if (context === undefined) {
        throw new Error('usePricing must be used within a PricingProvider');
    }
    return context;
};
